import React, { useContext, useState } from "react";
import api from "../../utils/api";

interface ICustomerEstimateContext {
  address: any;
  estimateValue: number;
  needsCustomQuote: boolean;
  onSubmit: (data: { address: string }) => Promise<number>;
}

export const CustomerEstimateContext = React.createContext<Partial<ICustomerEstimateContext>>({});

export const useCustomerEstimateContext = () => {
  const context = useContext(CustomerEstimateContext);
  if (context === undefined) {
    throw new Error("useCustomerEstimateContext must be used within a CustomerEstimateProvider");
  }
  return context as ICustomerEstimateContext;
};

export const CustomerEstimateProvider: React.FC = ({ children }) => {
  const [address, setAddress] = useState<any>("");
  const [estimateValue, setEstimateValue] = useState<any>(0);
  const [needsCustomQuote, setNeedsCustomQuote] = useState<boolean>(false);

  const getEstimate = async (address: any) => {
    return api.get("/customerCalculator", { params: { address: address } })
      .then(res => {
        if (res.data.error) {
          throw new Error(res.data.error);
        }
        if (process.env.NODE_ENV !== "production") {
          console.log("Estimate received: $" + res.data.finalEstimate);
        }
        setNeedsCustomQuote(res.data.needsCustomQuote);
        return res.data.finalEstimate;
      });
  };

  const onSubmit = async ({ address }: { address: string }): Promise<number> => {
    if (process.env.NODE_ENV !== "production") {
      console.log("Address submitted: " + address);
    }
    const estimateValue = await getEstimate(address);
    if (process.env.NODE_ENV !== "production") {
      console.log("Estimate: $" + estimateValue);
    }
    setEstimateValue(estimateValue);
    return estimateValue;
  };

  const value: ICustomerEstimateContext = {
    address,
    estimateValue,
    needsCustomQuote,
    onSubmit,
  };

  return (
    <CustomerEstimateContext.Provider value={value}>
      {children}
    </CustomerEstimateContext.Provider>
  );
};